import { render, staticRenderFns } from "./purchaseReceivingAction.vue?vue&type=template&id=04167b60&scoped=true"
import script from "./purchaseReceivingAction.vue?vue&type=script&lang=js"
export * from "./purchaseReceivingAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseReceivingAction.vue?vue&type=style&index=0&id=04167b60&prod&scoped=true&lang=css"
import style1 from "./purchaseReceivingAction.vue?vue&type=style&index=1&id=04167b60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04167b60",
  null
  
)

export default component.exports